import { render, staticRenderFns } from "./TechnologicalDevelopmentsPgHeader.vue?vue&type=template&id=389e648f&scoped=true&"
import script from "./TechnologicalDevelopmentsPgHeader.vue?vue&type=script&lang=js&"
export * from "./TechnologicalDevelopmentsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./TechnologicalDevelopmentsPgHeader.vue?vue&type=style&index=0&id=389e648f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e648f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
